const DEFAULT_TEMPLATE_REGEXP = new RegExp(':([\\w]+)', 'g');

type TemplateParams = {
  [key: string]: number | string;
};

export function microTemplate({
  template,
  params,
  regexp = DEFAULT_TEMPLATE_REGEXP,
}: {
  template: string;
  params: TemplateParams;
  regexp?: RegExp;
}): {
  result: string;
  params: TemplateParams;
} {
  const returnParams = { ...params };

  const result = template.replace(regexp, (v, k) => {
    delete returnParams[k];

    if (!params[k]) {
      throw new Error(`params: ${k} not found`);
    }

    return params[k].toString();
  });

  return {
    result,
    params: returnParams,
  };
}
